import React, { useState } from "react";
import "../styles/Createprod.css";
import { createProduct } from "../../../services/apiService"; // <- import service

const CreateProduct = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // For error handling
  const [formData, setFormData] = useState({
    focusid: "",
    firstName: "",
    category: "",
    subcategory: "",
    brand: "",
    modelno: "",
    sku: "",
    barcode: "",
    mrp: "",
    gst: 18,
    discount: "",
    delardiscount: "",
    keywords: "",
    description: "",
    minorderqty: 1,
    image1: "",
    image2: "",
    image3: "",
    exploreimage: "",
    active: 0,
    mappingid: 0,
    spec: [],
  });

  const name =localStorage.getItem("firstName");

  const basicFields = [
    { label: "Focus ID", key: "focusid", required: true },
    { label: "Category", key: "category", required: true },
    { label: "Subcategory", key: "subcategory", required: true },
    { label: "Brand", key: "brand", required: true },
    { label: "Model No", key: "modelno", required: true },
    { label: "SKU", key: "sku", required: true },
    { label: "Barcode", key: "barcode", required: true },
    { label: "MRP", key: "mrp", required: true },
    { label: "GST", key: "gst", required: true },
    { label: "Discount", key: "discount", required: true },
    { label: "Dealer Discount", key: "delardiscount", required: true },
    { label: "Keywords", key: "keywords", required: true },
    { label: "Minimum Order Quantity", key: "minorderqty", required: true },
    // { label: "Created By", key: "created_by", value: name, required: true },
    
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const addSpecField = () => {
    setFormData({
      ...formData,
      spec: [...formData.spec, { skey: "", value: "" }],
    });
  };

  const removeSpecField = (index) => {
    const updated = [...formData.spec];
    updated.splice(index, 1);
    setFormData({ ...formData, spec: updated });
  };

  const handleSpecChange = (index, field, value) => {
    const updated = [...formData.spec];
    updated[index][field] = value;
    setFormData({ ...formData, spec: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    // 🔥 BUILD API PAYLOAD HERE
    const payload = [
      {
        Product: {
          focusid: formData.focusid,
          category: formData.category,
          subcategory: formData.subcategory,
          brand: formData.brand,
          modelno: formData.modelno,
          sku: formData.sku,
          barcode: formData.barcode,
          mrp: formData.mrp,
          gst: formData.gst,
          discount: formData.discount,
          delardiscount: formData.delardiscount,
          keywords: formData.keywords,
          description: formData.description,
          minorderqty: formData.minorderqty,
          image1: formData.image1,
          image2: formData.image2,
          image3: formData.image3,
          exploreimage: formData.exploreimage,
          active: formData.active,
          mappingid: Number(formData.mappingid) || 0,
          netrate: formData.netrate,
          position: Number(formData.position) || 0,
          partno: Number(formData.partno) || 0,
          created_by: name || "",
          updated_by: "SuperAdmin",
        },
      },
      {
        spec: formData.spec,
      },
    ];

    try {
      const response = await createProduct(payload);
      console.log("Product created:", response.data);
      setSuccessMessage("Product created successfully!");
    } catch (error) {
      console.error("Error creating product:", error);
      setErrorMessage("Failed to create product. Please try again.");
    }
  };


  return (
    <div className="create-product">
      <h4 className="title">Create New Product</h4>

      {successMessage && <div className="alert-success">{successMessage}</div>}
      {errorMessage && <div className="alert-error">{errorMessage}</div>}

      <form onSubmit={handleSubmit}>
        {/* Basic Fields */}
        <div className="form-grid">
          {basicFields.map((field) => (
            <div className="form-group" key={field.key}>
              <label>{field.label}</label>
              <input
                type="text"
                name={field.key}
                value={formData[field.key]}
                onChange={handleChange}
                required={field.required}
              />
            </div>
          ))}
        </div>

        {/* Other Fields */}
        <div className="form-grid">
          {["description", "image1", "image2", "image3", "exploreimage", "active"].map(
            (key) => (
              <div className="form-group" key={key}>
                <label>{key.replace(/([A-Z])/g, " $1").toUpperCase()}</label>
                <input
                  type="text"
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  required
                />
              </div>
            )
          )}
        </div>

        {/* Misc Fields */}
        <div className="form-grid">
          {["mappingid", "netrate", "position", "partno"].map((key) => (
            <div className="form-group" key={key}>
              <label>{key.toUpperCase()}</label>
              <input
                type="text"
                name={key}
                value={formData[key]}
                onChange={handleChange}
                required
              />
            </div>
          ))}
        </div>

        {/* Specifications */}
        <div className="spec-box">
          <div className="spec-header">
            <h5>Product Specifications</h5>
            <button type="button" className="btn-sm" onClick={addSpecField}>
              + Add Spec
            </button>
          </div>

          {formData.spec.map((spec, i) => (
            <div className="spec-row" key={i}>
              <input
                className="spec-input"
                placeholder="Spec Key"
                value={spec.skey}
                onChange={(e) => handleSpecChange(i, "skey", e.target.value)}
              />
              <input
                className="spec-input"
                placeholder="Spec Value"
                value={spec.value}
                onChange={(e) => handleSpecChange(i, "value", e.target.value)}
              />
              <button
                type="button"
                className="btn-delete"
                onClick={() => removeSpecField(i)}
              >
                Delete
              </button>
            </div>
          ))}
        </div>

        <div className="form-submit">
          <button type="submit">Create Product</button>
        </div>
      </form>
    </div>
  );
};

export default CreateProduct;
